<div class="breadcrumb-bar"
    *ngIf="layoutService.layoutConf.useBreadcrumb && layoutService.layoutConf.breadcrumb === 'simple'">
    <ul class="breadcrumb">
        <li *ngFor="let part of routeParts"><a routerLink="/{{part.url}}"><small>{{part.breadcrumb}}</small></a></li>
    </ul>
</div>

<div class="breadcrumb-title"
    *ngIf="layoutService.layoutConf.useBreadcrumb && layoutService.layoutConf.breadcrumb === 'title'">
    <h1 class="bc-title">{{routeParts[routeParts.length -1]?.breadcrumb}}</h1>
    <ul class="breadcrumb" *ngIf="routeParts.length > 1">
        <li *ngFor="let part of routeParts"><a routerLink="/{{part.url}}" class="text-muted">{{part.breadcrumb}}</a>
        </li>
    </ul>
</div>